import { Box } from "@mittwald/flow-components/dist/components/Box";
import { color, spacing } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";

export const OffsetBox = styled(Box)`
  margin: -${spacing.inset.contentBox};
  padding: ${spacing.inset.contentBox};
  background-color: ${color.base.grey.$25};
  flex-basis: 40%;

  &.narrow {
    margin-top: 0;
  }

  &.wide {
    margin-left: 0;
  }
`;

export default OffsetBox;
